export const brandAssets = {
  logo: 'https://public.readdy.ai/ai/img_res/31da4028-d37e-4311-b71e-31a7936c0466.png',
  icon: 'https://public.readdy.ai/ai/img_res/f51e6118-bf3c-48d7-91f2-52e328c0f90d.png',
  model: 'https://public.readdy.ai/ai/img_res/f4783f43-6509-46e0-a1c6-8b9910b027ef.png',
};

export const comingSoonContent = {
  phone: '707-369-9830',
  whatsappUrl: 'https://wa.me/17073699830',
};